
import { computed, defineComponent, ref } from 'vue';
// import TheHeader from '@/components/TheHeader.vue';
import TheSidebar from '@/components/TheSidebar.vue';
import { useStore } from 'vuex';
import { key } from '@/store';

export default defineComponent({
  name: 'CienaLayout',
  components: {
    // TheHeader,
    TheSidebar,
  },
  props: {
    noSidebar: {
      type: Boolean,
      default: false,
    },
    noSearch: {
      type: Boolean,
      default: false,
    }
  },
  emits: ['onSearchBarSubmit'],
  setup() {
    const store = useStore(key);
    const isSidebarOpened = computed(() => store.state.layout.isSidebarOpen);

    const openSidebar = () => {
      store.commit('setSidebarState', true)
    };
    const closeSidebar = () => {
      store.commit('setSidebarState', false)
    };

    const onToggleSidebar = () => {
      store.commit('setSidebarState', !isSidebarOpened.value)
    }

    return {
      isSidebarOpened,
      openSidebar,
      closeSidebar,
      onToggleSidebar,
    };
  },
});
